import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { PopupService } from "src/app/shared/popup/popup.service";
import { TranslationModuleEnum } from "src/app/utils/translation-modules.enum";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-reason-sidebar",
  templateUrl: "./reason-sidebar.component.html",
  styleUrls: ["./reason-sidebar.component.scss"],
})
export class ReasonSidebarComponent implements OnInit {
  @Input() id: number;
  @Input() sidebarName: string;
  @Input() sidebarHeaderTitle: string;
  @Input() moduleEnum: number;
  @Input() isRequired: boolean;
  @Input() reasonLabel: string;
  @Input() reasonPlaceholder: string;
  @Input() reasonLabelTranslationKey: string;
  @Input() reasonPlaceholderTranslationKey: string;
  @Output() submit: EventEmitter<string> = new EventEmitter();

  isBtnLoading: any;
  form: FormGroup;
  translationModulesEnum = TranslationModuleEnum;

  constructor(
    private popupService: PopupService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      reason: new FormControl(
        null,
        this.isRequired ? [Validators.required] : []
      ),
    });
  }

  close() {
    this.popupService.close();
    this.form.reset();
    this.isBtnLoading = false;
  }

  onSubmit() {
    if (this.form.invalid) {
      return;
    }
    this.isBtnLoading = true;

    this.submit.emit(this.form.value.reason);
    this.close();
  }
}
